// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Register_wrapper__RLYQT","register-wrapper":"Register_register-wrapper__hDjFK","register":"Register_register__iVO6y"};